import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import Valentine from './containers/Valentine'
import FreePoints from './containers/FreePoints'
import LatestVotes from './containers/LatestVotes'
import MyVotes from './containers/MyVotes'
import MutualVotes from './containers/MutualVotes'
import Votes from './containers/Votes'
import Credits from './containers/Credits'

import createStore from './state/store'

let state = window.questionGameState
let props = window.questionGameProps

let store = createStore(state)

let doc = window.document

let valentineElement = doc.getElementById('render-component-valentine')

if (valentineElement != null) {
  ReactDOM.render(
    <Provider store={store}>
      <Valentine onVoted={props.onVoted}
        ageSliderVisible={valentineElement.getAttribute('data-age-slider-visible') == 'true'}
        player={props.player} gameType={props.gameType} /></Provider>,
    valentineElement
  )
}

let freePointsElement = doc.getElementById('render-component-free-points')

if (freePointsElement != null) {
  ReactDOM.render(
    <Provider store={store}><FreePoints player={props.player} gameType={props.gameType} /></Provider>,
    freePointsElement
  )
}

let latestVotesElement = doc.getElementById('render-component-latest-votes')

if (latestVotesElement != null) {
  ReactDOM.render(
    <Provider store={store}><LatestVotes gameType={props.gameType} /></Provider>,
    latestVotesElement
  )
}

let votesElement = doc.getElementById('render-component-votes')

if (votesElement != null) {
  ReactDOM.render(
    <Provider store={store}><Votes player={props.player} gameType={props.gameType} /></Provider>,
    votesElement
  )
  ReactDOM.render(
    <Provider store={store}><Credits /></Provider>,
    doc.getElementById('render-component-credits')
  )

}


let mutualVotesElement = doc.getElementById('render-component-mutual-votes')

if (mutualVotesElement != null) {
  ReactDOM.render(
    <Provider store={store}><MutualVotes gameType={props.gameType} /></Provider>,
    doc.getElementById('render-component-mutual-votes')
  )
}

let myVotesElement = doc.getElementById('render-component-my-votes')

if (myVotesElement != null) {
  ReactDOM.render(
    <Provider store={store}><MyVotes gameType={props.gameType} /></Provider>,
    doc.getElementById('render-component-my-votes')
  )
}
